import {
  Maybe,
  OrganizationNotificationBoxFragment,
} from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import {
  NotificationContentsTextCell,
  NotificationTitleCell,
} from '@/components/pages/NotificationDetail/template'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'
import { individualDisplayResponsive } from '@/core/individual'

export * from './fragments'

export type State = {
  loading: boolean
  notification: Maybe<OrganizationNotificationBoxFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const OfficialInformationDetailTemplate: Template<State, Action> = ({
  state: { notification, loading },
}) => {
  const { t } = useTranslation('officialInformationDetail')
  const { routerNames, generatePath, routerPages } = useRouter()

  const displayResponsive = individualDisplayResponsive()

  return (
    <BaseLayout
      header={{
        title: t(notification?.artist?.displayName ? 'titleArtist' : 'title', {
          displayName: notification?.artist?.displayName,
        }),
        back: true,
        defaultBackPage: generatePath(routerPages.OfficialInformation),
        ...(displayResponsive
          ? {
              responsive: true,
              maxWidth: 1120,
            }
          : {}),
      }}
      maxWidth={displayResponsive ? 1120 : undefined}
    >
      <Head
        title={`${notification?.artist?.displayName ?? ''}${
          routerNames.OfficialInformationDetail
        }`}
      />
      <NotificationTitleCell
        loading={loading}
        title={notification?.title ?? null}
        official
        date={notification?.formattedCreatedAt ?? null}
        artist={notification?.artist}
      />
      <NotificationContentsTextCell
        loading={loading}
        body={notification?.body ?? null}
      />
    </BaseLayout>
  )
}
